export default {
  desktop: {
    LiveThemeImporter: () => import(/* webpackChunkName: "topbet-themeWrap" */'./LiveThemeImporter'),
  },
  mobile: {
    LiveThemeImporter: () => import(/* webpackChunkName: "topbet-themeWrap" */'./LiveThemeImporter'),
  },
};
